<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="dialog-content">
    <h1>{{ 'REPRESENTATIVE.DIALOG.DELETE_HEADER' | translate }}</h1>
    <p>{{ 'REPRESENTATIVE.DIALOG.DELETE_TEXT' | translate }}</p>
    <!-- <app-check-box [control]="form.controls['shouldDeleteContact']"></app-check-box> -->
  </div>
  <div class="button-container">
    <button class="btn btn-cancel" (click)="cancel()">{{ 'CANCEL_BTN' | translate }}</button>
    <button class="btn btn-custom" type="submit">
      <img src="assets/icons/delete-icon-white.png" />
      {{ 'REPRESENTATIVE.FORM.DELETE_BUTTON' | translate }}
    </button>
  </div>
</form>
